import React from 'react';

const s = { stroke: 'currentColor', fill: 'none' };

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" {...s} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

export const TrendIcon = ({ className, width = '1.8' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none"><path d="M4 14l4-5 4 3 6-8" {...s} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" /></svg>
);

export const MailIcon = ({ size }) => (
  <svg viewBox="0 0 24 24" fill="none" width={size} height={size}>
    <path d="M3 6.5L12 13L21 6.5" {...s} strokeWidth="1.6" strokeLinecap="round" />
    <rect x="3" y="5" width="18" height="14" rx="2" {...s} strokeWidth="1.6" />
  </svg>
);

export const PhoneIcon = ({ size, width = '1.4' }) => (
  <svg viewBox="0 0 24 24" fill="none" width={size} height={size}>
    <path d="M6.5 3.5c1 1.2 1.5 2.4 1.5 3.4 0 1.3-1.7 1.7-1.7 3 0 2.6 4.3 6.9 6.9 6.9 1.3 0 1.7-1.7 3-1.7 1 0 2.2.5 3.4 1.5.4.3.4 1-.1 1.5l-1.3 1.3c-.6.6-1.5.9-2.5.7-3-.6-6-2.9-8.4-5.3S3.5 8.7 2.9 5.7c-.2-1 .1-1.9.7-2.5L4.9 1.9c.5-.5 1.2-.5 1.5-.1z" {...s} strokeWidth={width} strokeLinejoin="round" />
  </svg>
);

export const ChatIcon = ({ size }) => (
  <svg viewBox="0 0 24 24" fill="none" width={size} height={size}>
    <path d="M12 3C7 3 3 6.4 3 10.6c0 2.4 1.3 4.6 3.4 6-0.2.9-.7 2.1-1.7 3.2 1.6 0 3.2-.6 4.4-1.4.9.3 1.9.4 2.9.4 5 0 9-3.4 9-7.6S17 3 12 3z" {...s} strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

export const RupeeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none"><path d="M12 2v20M8 6h5.5a3 3 0 010 6H8m0 0h6a3 3 0 010 6H8" {...s} strokeWidth="1.5" strokeLinecap="round" /></svg>
);

export const ClockIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" {...s} strokeWidth="1.5" />
    <path d="M12 7v5l3.5 2" {...s} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const ChartIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none"><path d="M3 18l6-7 4 4 8-9" {...s} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

export const BoltIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none"><path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" {...s} strokeWidth="1.4" strokeLinejoin="round" /></svg>
);

export const SunIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none"><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" {...s} strokeWidth="1.5" strokeLinecap="round" /></svg>
);

export const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M4 21V10l8-6 8 6v11" {...s} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M9 21v-6h6v6" {...s} strokeWidth="1.5" />
  </svg>
);

export const BriefcaseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect x="3" y="7" width="18" height="13" rx="1.5" {...s} strokeWidth="1.5" />
    <path d="M8 7V5.5A2.5 2.5 0 0110.5 3h3A2.5 2.5 0 0116 5.5V7" {...s} strokeWidth="1.5" />
  </svg>
);

export const GrowthIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M4 17l5-6 4 4 7-9" {...s} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 6h5v5" {...s} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BagIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M6 8h12l1.5 12H4.5L6 8z" {...s} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M9 8V6a3 3 0 016 0v2" {...s} strokeWidth="1.5" />
  </svg>
);

export const QuoteIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 32 32" fill="currentColor">
    <path d="M9 8C4.5 8 1 11.8 1 16.5 1 21 4.2 24 8 24c.6 0 1.2-.1 1.7-.3-.7 3-2.5 5.5-2.5 5.5l2.3 1.3C12.8 27.5 15 22.9 15 17.5 15 12 12.2 8 9 8zm18 0c-4.5 0-8 3.8-8 8.5 0 4.5 3.2 7.5 7 7.5.6 0 1.2-.1 1.7-.3-.7 3-2.5 5.5-2.5 5.5l2.3 1.3C30.8 27.5 33 22.9 33 17.5 33 12 30.2 8 27 8z" transform="translate(-1)" />
  </svg>
);

export const MenuIcon = ({ open }) => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    {open
      ? <path d="M6 6l12 12M18 6L6 18" {...s} strokeWidth="1.8" strokeLinecap="round" />
      : <path d="M4 7h16M4 12h16M4 17h16" {...s} strokeWidth="1.8" strokeLinecap="round" />}
  </svg>
);
